import { useQuery } from "@tanstack/react-query";
import { getCandidateInterviewById } from "../Services/interviewService";

export const useInterviewById = (
  candidateId,
  interviewId,
  enabled = true
) =>
  useQuery({
    queryKey: ["interview", candidateId, interviewId],
    queryFn: () => getCandidateInterviewById(candidateId, interviewId),
    enabled: Boolean(candidateId && interviewId && enabled),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 5 * 60 * 1000,
    retry: false, // important for unauthorized access (403/404)
  });
